/**
 * Typed environment variable accessors.
 * All VITE_ variables are injected at build time by Vite.
 */

export const VITE_API_URL: string =
  import.meta.env["VITE_API_URL"] ?? "";

export const VITE_ENTRA_CLIENT_ID: string =
  import.meta.env["VITE_ENTRA_CLIENT_ID"] ?? "";

export const VITE_ENTRA_TENANT_ID: string =
  import.meta.env["VITE_ENTRA_TENANT_ID"] ?? "common";
